"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Alert;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _AlertMedium = _interopRequireDefault3(require("../../Icon/core/AlertMedium"));

var _Button = _interopRequireDefault3(require("../../Button"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _HelpMedium = _interopRequireDefault3(require("../../Icon/core/HelpMedium"));

var _InfoMedium = _interopRequireDefault3(require("../../Icon/core/InfoMedium"));

var _intl = require("../../utils/intl");

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireDefault3(require("react"));

var _SuccessMedium = _interopRequireDefault3(require("../../Icon/core/SuccessMedium"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/alert/index.css");

  require("../../spectrum-css/alert/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/alert/index-lg.css");
} else {
  require("../../spectrum-css/alert/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/alert/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/alert/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/alert/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/alert/multiStops/darkest.css");
var ICONS = {
  error: _AlertMedium["default"],
  warning: _AlertMedium["default"],
  info: _InfoMedium["default"],
  help: _HelpMedium["default"],
  success: _SuccessMedium["default"]
};
var formatMessage = (0, _intl.messageFormatter)(intlMessages);

function Alert(_ref) {
  var header = _ref.header,
      children = _ref.children,
      closeLabel = _ref.closeLabel,
      onClose = _ref.onClose,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      className = _ref.className,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? formatMessage(variant || 'info') : _ref$alt,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["header", "children", "closeLabel", "onClose", "variant", "className", "alt"]);
  var AlertIcon = ICONS[variant];
  return _react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('spectrum-Alert', "spectrum-Alert--".concat(variant), className),
    role: "alert"
  }, (0, _filterDOMProps["default"])(otherProps)), _react["default"].createElement(AlertIcon, {
    size: null,
    className: "spectrum-Alert-icon",
    alt: alt
  }), _react["default"].createElement("div", {
    className: "spectrum-Alert-header"
  }, header), _react["default"].createElement("div", {
    className: "spectrum-Alert-content"
  }, children), closeLabel && _react["default"].createElement("div", {
    className: "spectrum-Alert-footer"
  }, _react["default"].createElement(_Button["default"], {
    label: closeLabel,
    onClick: onClose,
    quiet: true,
    variant: "primary"
  })));
}

Alert.propTypes = {
  /**
   * A string for the header of the Alert
   */
  header: _propTypes["default"].string,

  /**
   * Any arbitrary node to render into content area
   */
  children: _propTypes["default"].node,

  /**
   * Affects the color and icon used by the Alert
   */
  variant: _propTypes["default"].oneOf(['error', 'warning', 'info', 'help', 'success']),

  /**
   * Label of the cancel button
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Callback when dialog closes
   */
  onClose: _propTypes["default"].func
};
Alert.defaultProps = {
  variant: 'info'
};
Alert.displayName = 'Alert';